import * as yup from 'yup'

const jazzInventoryTransactionUpdatedWebhookDataSchema = yup.object({
  sku_code: yup.string().nullable().optional(),
  facility_code: yup.string().nullable().optional(),
  business_type_code: yup.string().nullable().optional(),
  quantity: yup.number().nullable().optional(),
  reason_code: yup.string().nullable().optional(),
  transaction_id: yup.string().nullable().optional(),
  transaction_type: yup.string().nullable().optional(),
  po_number: yup.string().nullable().optional(),
  shipment_number: yup.string().nullable().optional(),
  order_number: yup.string().nullable().optional(),
  cost: yup.string().nullable().optional(),
  created_by: yup.string().nullable().optional(),
  note: yup.string().nullable().optional(),
  saleability: yup.string().nullable().optional(),
  lock_code: yup.string().nullable().optional(),
  facility_integrations: yup
    .array()
    .of(
      yup.object({
        id: yup.number().nullable().optional(),
        name: yup.string().nullable().optional(),
        attributes: yup.object().nullable().optional(),
      }),
    )
    .nullable()
    .optional(),
})

export const jazzInventoryTransactionUpdatedWebhookSchema =
  jazzInventoryTransactionUpdatedWebhookDataSchema.shape({
    doss_org_id: yup.string().required(),
    webhook_topic: yup.string().required(),
  })

export type JazzInventoryTransactionUpdatedData = yup.InferType<
  typeof jazzInventoryTransactionUpdatedWebhookSchema
>
